import React from "react";

const FALLBACK_COMMISSION = "/img/no-image.jpg";

export default function CommissionCard({ c, members = [], onOpen }) {
  return (
    <div
      className="cursor-pointer rounded-2xl overflow-hidden bg-white/90 dark:bg-slate-800/80 ring-1 ring-slate-200/70 dark:ring-slate-700/70 hover:shadow-lg transition"
      onClick={onOpen}
      title="Voir le détail de la commission"
      role="button"
      tabIndex={0}
      onKeyDown={(e) => (e.key === "Enter" || e.key === " ") && onOpen?.()}
    >
      <div className="relative h-40 w-full overflow-hidden">
        <img
          src={c?.photo_url || FALLBACK_COMMISSION}
          alt={c?.nom_commission || "Commission"}
          onError={(e) => (e.currentTarget.src = FALLBACK_COMMISSION)}
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-black/40 to-transparent" />
        <div className="absolute bottom-2 left-3 right-3">
          <h3 className="text-white text-lg font-bold drop-shadow line-clamp-2">
            {c?.nom_commission || "Commission"}
          </h3>
        </div>
      </div>

      <div className="p-4">
        {c?.description_commission ? (
          <p className="text-sm text-slate-700 dark:text-slate-300 line-clamp-3">
            {c.description_commission}
          </p>
        ) : (
          <p className="text-sm text-slate-500 italic">Description à venir.</p>
        )}

        <div className="mt-4 flex items-center justify-between">
          <div className="text-xs uppercase tracking-wide text-slate-500">
            {members.length} membre{members.length > 1 ? "s" : ""}
          </div>
          <span className="text-indigo-600 dark:text-indigo-400 text-sm font-medium">
            Voir le détail →
          </span>
        </div>
      </div>
    </div>
  );
}
